import Api from '../api.js'

const state = {
  endpointParent: '',
  endpointChild: ''
}

const getters = {}

const mutations = {}

const actions = {
  edit ({state}, {idParent, idChild, params}) {
    return new Promise((resolve, reject) => {
      Api.put(state.endpointParent + '/' + idParent + '/' + state.endpointChild + '/' + idChild, params, response => {
        resolve(response)
      }, response => {
        reject(response)
      })
    })
  },
  create ({state}, {idParent, idChild, params}) {
    return new Promise((resolve, reject) => {
      Api.post(state.endpointParent + '/' + idParent + '/' + state.endpointChild + '/' + idChild, params, response => {
        resolve(response)
      }, response => {
        reject(response)
      })
    })
  },

  delete ({state}, {idParent, idChild}) {
    return new Promise((resolve, reject) => {
      Api.delete(state.endpointParent + '/' + idParent + '/' + state.endpointChild + '/' + idChild, {}, response => {
        resolve(response)
      }, response => {
        reject(response)
      })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/common/relation.js